import { TopBar } from '@component/top_bar.component';
import { useResolveController, withNewContainer } from '@visiba/instantiation';
import { Navigate, Route, Routes, useParams } from 'react-router';
import { useEffect } from 'react';
import { Async } from '@component/async.component';
import { DynamicForm } from '@feature/dynamic_form/dynamic_form.component';
import { withTranslation } from '@application/i18n/with_translation';
import { Flex, Form } from '@cellula/react';
import { ScreenFormsController } from './screen_forms.controller';
import { ButtonArrange } from '@component/button_arrange.component';
import { ScreenError } from '../screen_error/screen_error';

export const ScreenForms = withNewContainer(function ScreenForms(): JSX.Element | null {
	const controller = useResolveController(ScreenFormsController);
	const forms = controller.forms.value ?? [];

	if (forms.length === 0) {
		return null;
	}

	return (
		<>
			<TopBar.Content goBack />
			<Routes>
				<Route path=':formId/:formPage?' element={<SingleForm />} />
				<Route path='*' element={<Navigate to={`./${forms[0].Id}`} replace />} />
			</Routes>
		</>
	);
});

function SingleForm() {
	const { formId, formPage = 0 } = useParams();
	const controller = useResolveController(ScreenFormsController);

	useEffect(
		function whenMount() {
			controller.loadSingleForm(Number(formId));
		},
		[controller, formId],
	);

	return (
		<Async derive={controller.formWorker} catch={<ScreenError />}>
			{(formWorker) => {
				return (
					<DynamicForm.Root formWorker={formWorker} defaultPagePosition={Number(formPage)}>
						<DynamicForm.Description />
						<DynamicForm.Content>
							<Flex grow={1} justify='flex-end'>
								<ButtonArrange>
									<Form.SubmitButton>{withTranslation('PW.Common.Next')}</Form.SubmitButton>
								</ButtonArrange>
							</Flex>
						</DynamicForm.Content>
					</DynamicForm.Root>
				);
			}}
		</Async>
	);
}
